import type { ReactNode } from "react";
import styles from "./section.module.css";

export function SectionHeader({ children }: { children: ReactNode }) {
  return <div className={styles.subheader}>{children}</div>;
}
